module.exports = __webpack_public_path__ + "static/hierarchyYes-34c796823fd781544c77501bf0c748d4.png";